module.exports = __webpack_public_path__ + "static/media/vue.3389d22e.png";